var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompltedTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.595,
    height: 15.595,
    viewBox: "0 0 15.595 15.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-up-right-svgrepo-com",
    d: "M7,21.181,21.181,7m0,0H12.106m9.075,0v8.546",
    transform: "translate(-6.293 -6.293)",
    fill: "none",
    stroke: "#7befc2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompltedTask);
export default __webpack_public_path__ + "static/media/complted_task.dd91a1f4cc375180a94e3966812fad1b.svg";
export { ForwardRef as ReactComponent };